<template>
  <image-cropper-upload :url="url" @uploaded="handleUploaded">
  </image-cropper-upload>
</template>

<script lang="babel">
import ImageCropperUpload from '@/components/ImageCropperUpload';

export default {
  components: {
    ImageCropperUpload,
  },
  props: {
    customerProfile: {
      required: true,
      type: Number,
    }
  },
  methods: {
    handleUploaded(media) {
      this.$bus.$emit('media-uploaded', media);
    }
  },
  computed: {
    url() {
      return `/api/v1/customerProfile/${this.customerProfile}/customerMedia`;
    }
  },
}
</script>
